package com.iregained.site.region

// 1. Define a blueprint for all the text that changes per region
interface AppStrings {
    val currencySymbol: String
    val supportPhone: String
    val emailText: String      // Used for general inquiries / header / footer
    val supportEmail: String   // Used for clinical software / tech support
    val investorEmail: String  // Used for HQ / investors
}

// 2. Create the USA version
object StringsUS : AppStrings {
    override val currencySymbol = "$"
    override val supportPhone = "+1 (807) 355-6979"
    override val emailText = "info@iregained.us"
    override val supportEmail = "support@iregained.us"
    override val investorEmail = "investors@iregained.rehab"
}

// 3. Create the India version
object StringsIN : AppStrings {
    override val currencySymbol = "₹"
    override val supportPhone = "+91 91508 90033"
    override val emailText = "info@iregained.in"
    override val supportEmail = "support@iregained.in"
    override val investorEmail = "info@iregained.rehab"
}

// 4. Create the Canada (Global) version
object StringsCA : AppStrings {
    override val currencySymbol = "$"
    override val supportPhone = "+1 (807) 355-6979"
    override val emailText = "info@iregained.rehab"
    override val supportEmail = "support@iregained.rehab"
    override val investorEmail = "info@iregained.rehab"
}

// 5. THE MAGIC TRICK: A single variable that automatically grabs the right text!
val activeStrings: AppStrings
    get() = when (RegionConfig.currentRegion) {
        Region.US -> StringsUS
        Region.INDIA -> StringsIN
        Region.CANADA -> StringsCA
    }

